import React, { useState } from 'react';
import { DoLogin, ShowPWD, Translate } from './Functions';
import ReCAPTCHA from "react-google-recaptcha";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Input, CheckBox, Button} from './Controls/Controls';

function Login() 
{
    document.body.style.backgroundColor = "rgb(245 245 245);";
    localStorage.setItem("clearedLocalStorage", "true");
    
    const recaptchaRef = React.createRef();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [recaptchaValue, setRecaptcha] = useState("");

    const handleUsernameChange = (value) => {
        setUsername(value);
    }

    const handlePasswordChange = (value) => {
        setPassword(value);
    }

    const handleGoogleCaptcha = () => {
        setRecaptcha(recaptchaRef.current.getValue());
    }

    return (
        <div className="App">
            <ToastContainer />
            <div className="container login-logo-pos">
                <div className="d-flex flex-row-reverse">
                    <a href="/">
                    <img src="https://static.wixstatic.com/media/e2f2a9_e58de2ec1ac84060afdf68c4b4ea1726~mv2.png/v1/fill/w_332,h_111,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/IFMS_LOGO.png" className="nav-logo" alt="logo" />
                    </a>
                </div>
            </div>
            <div className="login text-center">
                <h1>Login</h1>
                <br />

                <Input inputID={"login_username"} inputType={"text"} inputOptionalParams={ {onChange: (e) => handleUsernameChange(e.target.value), "placeholder": Translate("Username")} } />
                <Input inputID={"login_password"} inputType={"password"} inputOptionalParams={ {onChange: (e) => handlePasswordChange(e.target.value), "placeholder": Translate("Password")} } />
                <CheckBox chkID={"login_showPwd"} chkType={"checkbox"} chkText={ Translate("Show password") } inputOptionalParams={ {onChange: () => ShowPWD("login_password")} } />

                <br />
                {/* <div className="d-flex justify-content-center">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6Lehk9UbAAAAAPo0GjA4LP2Ji5dNzu3W6v7S9fxj"
                        onChange={handleGoogleCaptcha}
                    />
                </div> */}

                <Button btnID={"login_button"} btnClassName={""} btnText={ Translate("Login") } inputOptionalParams={{ onClick: () => DoLogin(username, password, recaptchaValue) }} />
            </div>
        </div>
    );
}
  
export default Login;